<fuse-card class="flex flex-col">
  <div class="border-b px-4 py-3 text-base font-bold uppercase">
    <a class="text-primary" routerLink="/communication/surveys" [queryParams]="{ _ref: 'dashboard' }">Active Surveys</a>
  </div>
  <div class="max-h-96 overflow-y-auto">
    @if (loading) {
      <div class="flex justify-center p-4">
        <mat-spinner diameter="36" color="primary"></mat-spinner>
      </div>
    }
    @if (surveys.length && !loading) {
      <div class="overflow-auto">
        <table class="w-full text-base">
          <thead class="text-secondary bg-slate-50 text-base font-semibold">
            <tr>
              <th class="px-3 py-2 text-start">Title</th>
              <th class="px-3 py-2 text-start">Community</th>
              <th class="px-3 py-2 text-start">Participation</th>
              <th class="px-3 py-2 text-start">Published on</th>
              <th class="px-3 py-2 text-start">Expires on</th>
            </tr>
          </thead>
          <tbody class="divide-y">
            @for (item of surveys; track item.id) {
              <tr class="hover:bg-slate-50">
                <td class="px-3 py-2" data-auto-clamp="2">
                  <a class="cursor-pointer font-medium text-primary hover:underline" (click)="openReportModal(item)">
                    {{ item.title }}
                  </a>
                </td>
                <td class="min-w-48 px-3 py-2" data-auto-clamp="2">{{ item.association?.name }}</td>
                <td class="px-3 py-2">
                  <div class="flex items-center gap-2">
                    <div class="h-2 w-20 overflow-hidden rounded-full bg-gray-300">
                      <div class="h-full rounded-full bg-gray-500" [style.width.%]="item.participation_rate || 0"></div>
                    </div>
                    <span class="text-secondary text-sm">{{ item.participation_rate || 0 }}%</span>
                  </div>
                </td>
                <td class="px-3 py-2">
                  <span data-nowrap>{{ item.published_at | date: 'mediumDate' }}</span
                  ><br />{{ item.published_at | date: 'mediumTime' }}
                </td>
                <td class="px-3 py-2">
                  <span data-nowrap>{{ item.expire_at | date: 'mediumDate' }}</span
                  ><br />{{ item.expire_at | date: 'mediumTime' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @if (!loading && !surveys.length && !error) {
      <div class="text-secondary flex flex-col items-center justify-center py-6">
        <mat-icon fontIcon="poll" class="mb-1 icon-size-6"></mat-icon>
        <span class="text-base">No active surveys</span>
      </div>
    }
  </div>
</fuse-card>
